<template>
  <b-modal
    v-if="org && !org.accepted"
    id="org-invite"
    size="sm"
    centered
    hide-footer
    hide-header
  >
    <div class="py-2 text-center">
      You have been invited to join
      <h2>{{ org.name }}</h2>
    </div>
    <div class="d-flex">
      <b-btn
        class="my-0 mr-1"
        variant="outline-primary"
        block
        @click="$bvModal.hide('org-invite')"
      >
        Dismiss
      </b-btn>
      <b-btn
        class="my-0 ml-1"
        variant="primary"
        block
        @click="$router.push('/org')"
      >
        View Invite
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      org: "user/org"
    })
  },

  mounted() {
    if (this.org && !this.org.accepted) {
      this.$bvModal.show("org-invite");
    }
  }
};
</script>
